/* eslint-disable no-unused-vars */
import { curry } from 'lib/util'
/**
 * Sets the `query` parameter for the current search to only include items that are of the specified
 * doc type.
 *
 * @param {Gaia.AppModule.Spec} module      app module
 * @param {Gaia.Component.Spec} component   action component
 * @param {Event|object} event              information about the event that triggered this handler
 * @returns {Object}
 */
const isOrganisationOrPersonOrRequestOrServiceItem = (module, component, event) => ({
  type: ['organisation', 'person', 'request', 'serviceitem'],
})

export default curry(isOrganisationOrPersonOrRequestOrServiceItem)
